import SlideUp from "../motions/SlideUp";

const Footer = () => {
  return (
    <SlideUp triggerOnView={true}>
      <div className="p-12">
        <img
          src="/assets/images/home/BigLogo.png"
          alt="Wedding Logo"
          className="mx-auto"
        />
      </div>
    </SlideUp>
  );
};


export default Footer;
